export default __webpack_public_path__ + "static/media/auction-toggle-1.0d537971.jpg";